import { render, staticRenderFns } from "./riskOfficeInfo.vue?vue&type=template&id=4bdf4c4e"
import script from "./riskOfficeInfo.vue?vue&type=script&lang=js"
export * from "./riskOfficeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdf4c4e')) {
      api.createRecord('4bdf4c4e', component.options)
    } else {
      api.reload('4bdf4c4e', component.options)
    }
    module.hot.accept("./riskOfficeInfo.vue?vue&type=template&id=4bdf4c4e", function () {
      api.rerender('4bdf4c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskOfficeInfo.vue"
export default component.exports